export default __webpack_public_path__ + "static/media/robustoOpen.299bcebb.jpg";